<template>
  <span :class="[$style.chip, $style[`chip--${variation}`]]">
    {{ text }}
  </span>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

type Variation = 'positive' | 'negative' | 'alert' | 'running'

export default defineComponent({
  name: 'StateChip',
  props: {
    variation: {
      type: String as PropType<Variation>,
      default: 'positive',
    },
    text: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" module>
.chip {
  display: inline-flex;
  height: 22px;
  box-sizing: border-box;
  align-items: center;
  padding: 0 14px 1px;
  background-color: $color-surface-accent-primary;
  border-radius: 999em;
  color: $color-text-and-object-high-emphasis-inverse;
  font-size: 12px;
  font-weight: bold;

  &--positive {
    background-color: $color-label-green;
  }

  &--negative {
    background-color: $color-label-gray;
  }

  &--alert {
    background-color: $color-label-red;
  }

  &--running {
    background-color: $color-label-blue;
  }
}
</style>
